module.exports = __webpack_public_path__ + "fonts/Rubik-300-cyrillic9.3ecd4ac.woff2";